import { analytics } from "../firebaseConfig";
import { logEvent } from "firebase/analytics";

export const trackPageView = (pageName) => {
  if (analytics) {
    logEvent(analytics, "page_view", { page_title: pageName });
  }
};

export const trackEvent = (eventName, params = {}) => {
  if (analytics) {
    logEvent(analytics, eventName, params);
  }
};

export const trackFormSubmit = (formName) => {
  trackEvent("form_submit", { form_name: formName });
};

export const trackButtonClick = (buttonName, location) => {
  trackEvent("button_click", { button_name: buttonName, location });
};

export const trackExternalLink = (url, label) => {
  trackEvent("external_link_click", { url, label });
};
